import { rockApi, unwrapRockResponse } from "../../services/rockApiClient";

export function login({ email, password }) {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    const resp = await rockApi.post("/auth/login", formData);
    const data = unwrapRockResponse(resp);

    localStorage.setItem("access_token", data.access_token);
    dispatch({
      type: "AUTH/LOGIN_SUCCESS",
      payload: { user: data.user, token: data.access_token }
    });
  };
}

export function logout() {
  return (dispatch) => {
    localStorage.removeItem("access_token");
    dispatch({ type: "AUTH/LOGOUT" });
  };
}
